module.exports = __webpack_public_path__ + "img/nocauteada.777bfbff.png";